import { editorialStatusBlock, button, numberedSteps } from "../../design/components.js";

export interface PermissionsCtx {
  t: (k: string, p?: Record<string, string | number>) => string;
  onNext: () => void;
  onBrowse: () => void;
}

/** Onboarding screen 2 — JIT-honest permissions. Explains only; OS prompts fire on
 *  first actual use (onboarding spec §4). "Set up later" fully works (browse-only). */
export function permissionsScreen(ctx: PermissionsCtx): HTMLElement {
  const root = document.createElement("section");
  root.className = "screen onboarding-permissions";
  root.append(
    editorialStatusBlock({
      microlabel: ctx.t("onboarding.perms.step"),
      headline: ctx.t("onboarding.perms.title"),
    }),
  );

  root.append(
    numberedSteps(
      [
        ctx.t("onboarding.perms.location"),
        ctx.t("onboarding.perms.notifications"),
        ctx.t("onboarding.perms.background"),
      ],
      -1, // none "current": these are explanations, not a wizard with active steps
    ),
  );

  const next = button({ label: ctx.t("onboarding.perms.continue"), variant: "primary", onClick: ctx.onNext });
  next.setAttribute("data-action", "next");
  next.setAttribute("aria-label", ctx.t("onboarding.perms.continue"));

  const later = button({ label: ctx.t("onboarding.perms.later"), variant: "secondary", onClick: ctx.onBrowse });
  later.setAttribute("data-action", "later");
  later.setAttribute("aria-label", ctx.t("onboarding.perms.later"));

  root.append(next, later);
  return root;
}
